<template>
  <el-dialog class="yto-dialog" :title="step === 2 ? '绑定成功' : '更换头像'" @open="openDialog" @close="closeDialog" :visible.sync="isShow"
  :close-on-click-modal="false" :modal="false">
    <div class="tip-dialog" v-if="step === 2">
      <span class="success-icon">
        <svg-icon icon-class="success"></svg-icon>
      </span>
      <p class="tip-text">头像更换成功！</p>
    </div>
    <div v-else>
      <el-upload
          ref="uploadFile"
          class="avatar-uploader"
          action="/steward-api/issue/upload"
          :headers="headers"
          :show-file-list="false"
          :before-upload="beforeAvatarUpload"
          :on-success="uploadSuccess">
        <img v-if="imageUrl" :src="imageUrl" class="avatar">
        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
      </el-upload>
      <p class="tip-text">仅支持JPEG、JPG、PNG图片文件，且文件小于1M。</p>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button v-if="step === 2" @click="closeDialog" plain>关 闭</el-button>
      <template v-else>
        <el-button @click="closeDialog" plain>取 消</el-button>
        <el-button @click="finish" type="primary">确 定</el-button>
      </template>
    </div>
  </el-dialog>
</template>

<script>
import { getStore } from '@/utils/localStorage';
import { changeAvatarApi } from '@/api/systemModule/accountSetting/info';
export default {
  components: {},
  computed: {
    userMess() {
      return this.$store.state.user;
    }
  },
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    value(val) {
      this.isShow = val;
    }
  },
  data() {
    return {
      imageUrl: '',
      picId: '',
      isShow: this.value,
      step: 1,
      headers: {
        'source': 'YTO-STEWARD',
        'jwt-token': getStore('stewoard-token')
      }
    };
  },
  created() {
  },
  methods: {
    // 上传前
    beforeAvatarUpload(file) {
      if (!/^image\/(jpeg|png)$/.test(file.type)) {
        this.$alert('上传图片暂时只支持JPEG、JPG、PNG格式', '提示', {
          confirmButtonText: '关闭',
          type: 'error'
        });
        return false;
      }
      if (file.size > 1 * 1024 * 1024) {
        this.$alert('图片大小1M以内', '提示', {
          confirmButtonText: '关闭',
          type: 'error'
        });
        return false;
      }
      return true;
    },
    // 上传成功
    uploadSuccess(res, file, fileList) {
      this.picId = res.id;
      this.imageUrl = URL.createObjectURL(file.raw);
    },
    openDialog() {
      this.step = 1;
      this.picId = '';
      this.imageUrl = '';
    },
    // 完成
    finish() {
      changeAvatarApi(this.picId).then(() => {
        this.step = 2;
        this.$emit('update');
      });
    },
    // 关闭dialog
    closeDialog() {
      this.isShow = false;
      this.$emit('close', this.isShow);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" rel="stylesheet/scss" scoped>
.avatar-uploader /deep/ {
  .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    &:hover {
      border-color: #409EFF;
    }
  }
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>
